import { computed } from 'vue';
import _ from 'lodash';

// config column hiển thị Cột quy đổi
export const useCurrencyShowColumn = (proxy, columnsParalell) => {
  /**
   * Ẩn hiện column hạch toán đồng thời
   * NXCHIEN 17.05.2022
   */
  const columnsDataParalell = computed(() => {
    // chứng từ nào ko muốn ẩn cột amount thì thêm vào đây
    let listRefType = [
      proxy.$ms.constant.RefType.BUTransferPurchase,
      proxy.$ms.constant.RefType.CAPaymentPurchase,
      proxy.$ms.constant.RefType.BAWithdrawPurchase,
      proxy.$ms.constant.RefType.FAAdjustment,
    ];

    // NBTIN Sửa: Case thêm vì chứng từ đánh giá lại không có cột currency_code trên model ở master nên luôn không có giá trị
    if (proxy.model.currency_code || listRefType.find(x => x === proxy.model.ref_type)) {
      let data = _.cloneDeep(columnsParalell);
      data.forEach(item => {
        if (item.dataField == 'amount_oc' && proxy.model.currency_code != proxy.$t('i18nEnum.Currency.VND')) {
          item.formatType = proxy.$ms.constant.FormatType.AmountOC;
        }
        switch (item.dataField) {
          case 'budget_provide_code': // mã dự phòng
            if (!proxy.dbOptions.IsDetailbyBudgetProvidence) {
              item.visible = false;
            } else {
              item.visible = true;
            }
            break;
          case 'budget_detail_item_code': //Tiết tiểu mục
            if (!proxy.dbOptions.AccountingBudgetDetailItemCode) {
              item.visible = false;
            } else {
              item.visible = true;
            }
            break;
          case 'contract_no': // Hợp đồng
            if (!proxy.dbOptions.UseContract) {
              item.visible = false;
            }
            break;
          case 'task_code': // Nhiệm vụ
            if (!proxy.dbOptions.UseTask) {
              item.visible = false;
            } else {
              item.visible = true;
            }
            break;
          case 'is_source_before_year': // Nguồn năm trước
            if (!proxy.dbOptions.UseSourceBeforeYear) {
              item.visible = false;
            } else {
              item.visible = true;
            }
            break;
          // case 'topic_code': // đề tài
          //   if (!proxy.dbOptions.UseTopicManagement) {
          //     item.visible = false;
          //   } else {
          //     item.visible = true;
          //   }
          //   break;
          case 'debit_account':
          case 'credit_account':
          case 'budget_source_name':
            var arr = {
              name: item.dataField == 'budget_source_name' ? 'unSuitBudget' : 'unSuitAccount',
            };
            if (item.rules && Array.isArray(item.rules)) {
              item.rules.push(arr);
            } else {
              item.rules = [arr];
            }
            break;
        }
      });

      if (
        proxy.model.currency_code != proxy.$t('i18nEnum.Currency.VND') &&
        !listRefType.find(x => x === proxy.model.ref_type)
      ) {
        data.forEach(x => {
          if (x.dataField == 'amount') {
            x.visible = true;
          }
        });
      }

      return data;
    }

    return columnsParalell;
  });

  return {
    columnsDataParalell,
  };
};
